'use client';

import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useRouter } from "next/navigation";
import google from '../../../public/assets/google.svg';
import Image from "next/image";
import AutoSwipeRed from "@/app/components/AutoSwipeRed";
import EyeOpen from '../../../public/assets/eyeOpen.svg';
import EyeClose from '../../../public/assets/eyeClose.svg';
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { useEffect } from "react";
import { NEXT_PUBLIC_GOOGLE_CLIENT_ID } from "@/config"


interface FormData {
    email: string;
    password: string;
    access_token: string;
    id: string;
}

export default function LoginPage() {
    
    const router = useRouter();
    const { register, handleSubmit, formState: { errors }, watch, reset } = useForm<FormData>();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isGoogleLoading, setIsGoogleLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [showPassword, setShowPassword] = useState(false);
    const password = watch("password");
    const [currentStep, setCurrentStep] = useState(4);
    const totalSteps = 4;
    const clientId = NEXT_PUBLIC_GOOGLE_CLIENT_ID;


const handleSuccess = async (credential: any) => {
    console.log("Google login response:", credential);
    setIsGoogleLoading(true);
    setErrorMessage(null);
  
    try {
      const response = await fetch("/api/auth/google", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(credential),
      });
  
      const result = await response.json();

      console.log("Backend response:", result);
      if (!response.ok) {
        if (response.status === 401) {
            setErrorMessage('Password is not correct')
        } else if (response.status === 404) {
            setErrorMessage('Email does not exist')
        } else {
            setErrorMessage(result.message || 'Login failed, please try again')
        }
        setIsGoogleLoading(false);
        return;
    }

    console.log("Success:", result);
     
    reset();
    router.push("/dashboard");
    } catch (error) {
      console.error("Error verifying Google login:", error);
      setErrorMessage("Google login failed. Please try again or use a different login method.");
      setIsGoogleLoading(false);
    }
  };



const onSubmit = async (data: FormData) => {
        console.log('Form Submitted:', data);
        setIsSubmitting(true);
        setErrorMessage(null);

        try {
            console.log(clientId, 'this is the client Id')
            const response = await fetch("/api/auth/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            });

            const result = await response.json();
            setIsSubmitting(false);

            if (!response.ok) {
                if (response.status === 401) {
                    setErrorMessage('Password is not correct')
                } else if (response.status === 404) {
                    setErrorMessage('Email does not exist')
                } else {
                    setErrorMessage(result.message || 'Login failed, please try again')
                }
                return;
            }

            console.log("Success:", result);
             
            reset();
            router.push("/dashboard");
        } catch (error) {
            console.error("Error during login:", error);
            setIsSubmitting(false);
            setErrorMessage("An unexpected error occurred, please try again.");
        }
    };

    return (
        <div className="min-h-screen justify-center flex flex-col md:flex-row items-start md:items-center">
                     <AutoSwipeRed startIndex={1} />
          
   
            <div className="w-full md:w-1/2 flex justify-center flex-col items-center px-4 sm:px-6 bg-white py-8 md:py-0">
                <form className="w-full max-w-md" onSubmit={handleSubmit(onSubmit)}>
                    <h1 className="text-xl sm:text-2xl font-medium text-black mb-3 md:mb-4">Login</h1>
                    <p className="text-black-light mb-4 md:mb-6 font-normal text-sm sm:text-base">Welcome back!</p>
                    {errorMessage && <p className="text-primary mb-4">{errorMessage}</p>}
                    
                    <div style={{ border: '1px solid #ccc', borderRadius: "24px", overflow: "hidden" }}>
  {/* <GoogleOAuthProvider clientId={clientId || ""}>
    <GoogleLogin
      onSuccess={handleSuccess}
      onError={() => console.log("Login Failed")}
      theme="outline"
      size="large"
      width="100%"
      useOneTap
      auto_select={false}
    />
  </GoogleOAuthProvider> */}
  <GoogleOAuthProvider clientId={clientId}>
  <GoogleLogin
    onSuccess={handleSuccess}
    onError={() => console.log("Login Failed")}
    theme="outline"
    size="large"
    useOneTap
    auto_select={false}
    ux_mode="popup"
  />
</GoogleOAuthProvider>
</div>

                  
                  


                    <div className="flex justify-center items-center w-full my-4">
                     <div className="flex items-center w-1/2">
                     <div className="flex-1 h-px bg-black-dark"></div>
                    <span className="px-3 text-[#9E9E9E] text-sm font-normal">or with</span>
                   <div className="flex-1 h-px bg-black-dark"></div>
                   </div>
                  </div>


                    {/* google ends */}

                    {/* Email */}
                    <div className="mb-4">
                        <label className="mb-4 block text-base text-black-light">Enter your Email Address</label>
                        <Input
                            type="email"
                            placeholder="e.g Adeyo@gmail.com"
                            {...register('email', {
                                required: 'Email is required',
                                pattern: {
                                    // value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
                                    value: /^[\w-\.]+(\+[\w0-9]+)?@([\w-]+\.)+[\w-]{2,4}$/g,
                                    message: 'Enter a valid email'
                                    // value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
                                }
                            })}
                            className={`w-full min-h-11  mt-1 rounded-full placeholder:text-placeholder-gray ${errors.email ? 'border-primary' : 'border-black-dark'}`}
                        />
                        {errors.email && <p className="text-primary">{errors.email.message}</p>}
                    </div>
                     <div className="mb-4 relative">
                    <label className="block text-sm text-black-light">Enter Password</label>
                    <div className="relative">
                        <Input
                            type={showPassword ? "text" : "password"}
                            placeholder="*************"
                            {...register('password', {
                                required: 'Please enter your password',
                            })}
                            className={`w-full min-h-11 mt-1 rounded-full placeholder:text-placeholder-gray ${errors.password ? 'border-primary' : 'border-black-dark'}`}
                        />
                        <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute top-1/2 transform -translate-y-1/2 right-3 focus:outline-none"
                        title={showPassword ? "Hide Password" : "Show Password"}
                        >
                            <Image
                            src={showPassword ? EyeOpen : EyeClose}
                            alt={showPassword ? "Hide Password" : "Show Password"}
                            width={20}
                            height={20}
                            />
                        </button>
                      </div>
                        {errors.password && <p className="text-primary">{errors.password.message}</p>}
                    </div>
                    {/* Terms and Conditions */}
                    <div className="flex mb-6 justify-end items-center">
                    
                     <a href="/auth/password-recovery" className="text-primary font-medium">Forgot Password?</a> 
                    </div>

                    {/* Submit Button */}
                    <Button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full border-black-dark min-h-11  mt-1 rounded-full h-12 bg-primary text-white"
                    >
                        {isSubmitting ? 'Submitting...' : 'Login'}
                    </Button>
                    <div className="flex justify-start text-base text-[#333333] py-2">Don’t have an account? 
                            <span className="">
                                <a href="/auth/signup" className="text-primary font-bold underline ml-1">Create One.</a>
                            </span>
                        </div>
                </form>
            </div>
        </div>
    );
}